import { FormEvent, useState } from "react";
import { Bot } from "lucide-react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth, useLogin } from "../hooks/useAuth";

export function LoginPage() {
  const auth = useAuth();
  const login = useLogin();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  if (auth.isSuccess) {
    return <Navigate to="/dahsbot" replace />;
  }

  const submit = (event: FormEvent) => {
    event.preventDefault();
    login.mutate({ email, password }, { onSuccess: () => navigate("/dahsbot") });
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 px-6 text-slate-100">
      <form
        onSubmit={submit}
        className="w-full max-w-md rounded-3xl border border-white/10 bg-white/[0.05] p-8 shadow-2xl"
      >
        <div className="mb-8 flex items-center gap-3">
          <div className="rounded-2xl bg-emerald-400 p-3 text-slate-950">
            <Bot className="h-7 w-7" />
          </div>
          <div>
            <h1 className="text-2xl font-semibold">Accedi</h1>
            <p className="text-sm text-slate-400">Dashboard chatbot WhatsApp</p>
          </div>
        </div>

        <label className="mb-4 block">
          <span className="mb-2 block text-sm text-slate-300">Email</span>
          <input
            type="email"
            name="email"
            autoComplete="username"
            required
            className="w-full rounded-xl border border-white/10 bg-slate-900 px-4 py-3 outline-none ring-emerald-400 focus:ring-2"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </label>

        <label className="mb-6 block">
          <span className="mb-2 block text-sm text-slate-300">Password</span>
          <input
            type="password"
            name="password"
            autoComplete="current-password"
            required
            className="w-full rounded-xl border border-white/10 bg-slate-900 px-4 py-3 outline-none ring-emerald-400 focus:ring-2"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </label>

        {login.isError && (
          <p className="mb-4 rounded-xl bg-red-500/10 p-3 text-sm text-red-300">Login non riuscito.</p>
        )}

        <button
          disabled={login.isPending}
          className="w-full rounded-xl bg-emerald-400 px-4 py-3 font-semibold text-slate-950 hover:bg-emerald-300 disabled:opacity-60"
        >
          {login.isPending ? "Accesso..." : "Entra"}
        </button>
      </form>
    </div>
  );
}
